/**
 * Event for production chart refreshing.
 */
export const PRODUCTION_CHART_REFRESH_EVENT = "productionChartRefresh";
